import { ReactNode, useEffect } from 'react';
import { SidebarContext, useSidebarProvider } from '@/hooks/use-sidebar';
import { addSidebarTransitionStyles } from '@/lib/utils';

interface SidebarProviderProps {
  children: ReactNode;
}

export function SidebarProvider({ children }: SidebarProviderProps) {
  const sidebarContext = useSidebarProvider();

  // Add the CSS transitions when the component mounts
  useEffect(() => {
    addSidebarTransitionStyles();
  }, []);

  return <SidebarContext.Provider value={sidebarContext}>{children}</SidebarContext.Provider>;
}
